var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "dashBoard_promotion" },
        [
          _c("DashboardHeader", {
            attrs: { abo: _vm.aboInfo.aboNo, name: _vm.aboInfo.aboName }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "abo-dashboard" },
            [
              _c(
                "div",
                { staticClass: "main-dash_section" },
                [
                  _c("DashboardContentsAttainment", {
                    attrs: { attainmentlevel: _vm.attainment.level },
                    on: { layer: _vm.showLayerAttinment }
                  }),
                  _vm._v(" "),
                  _c("DashboardContentsAbocardList", {
                    attrs: {
                      abocardlist: _vm.aboCardList,
                      deadline: _vm.deadline,
                      isplatium: _vm.isPlatinum
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("DashboardLayerAttainmentMessage")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("DashboardLayerAttainment", { on: { layer: _vm.closeLayer } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "skipToContent" } }, [
      _c("a", { attrs: { href: "#contents" } }, [_vm._v("콘텐츠 바로가기 ")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7033cc0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7033cc0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sales/dashboard2/dashboard.vue
// module id = null
// module chunks = 